import {Injectable} from '@angular/core';
import {AbstractModelService} from '../model/abstract-model.service';
import {ApiClientService} from '../api-client/api-client.service';
import {AbstractWidget} from '../../models/cms/widget/abstract-widget';
import {Observable} from 'rxjs';
import {ApiResponse} from '../../api/api-response';
import {ThemeSchema} from '../../models/cms/widget/theme/theme-schema';

@Injectable({
  providedIn: 'root'
})
export class WidgetService extends AbstractModelService<AbstractWidget> {
  constructor(apiClient: ApiClientService) {
    super(apiClient, '/widget', AbstractWidget);
  }

  getThemeSchema(widgetType: string): Observable<ThemeSchema | null> {
    return new Observable<ThemeSchema | null>((subscriber) => {
      this.apiClient.get(this.routePath + '/theme-schema', {type: widgetType}).subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData() ? new ThemeSchema().deserialize(response.getData()) : null);
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }

  request(widget: AbstractWidget, country: string, theme: any | null = null): Observable<any> {
    return new Observable<any>((subscriber) => {
      this.apiClient.post(this.routePath + '/' + widget.id + '/request', null, {
        country,
        theme,
        options: widget.options,
        preview: true
      }).subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData());
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }

  getWidgetList(): Observable<any[]> {
    return new Observable<any[]>((subscriber) => {
      this.apiClient.get(this.routePath + '/list').subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData());
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }

  getWidgetOptions(widgetType: string): Observable<any[]> {
    return new Observable<any[]>((subscriber) => {
      this.apiClient.get(this.routePath + '/options', {type: widgetType}).subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData());
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }
}
